var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpressEntryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_315_1425)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 32,
    r: 21,
    fill: "#FFC13F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_315_1425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0908 38.9576V40.4367L47.61 26.4609H47.2107L35.0908 38.9576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4605 38.6319H33.1911V38.0144C33.4749 37.8779 33.6703 37.5878 33.6683 37.2521C33.642 33.1082 32.9164 30.3665 31.5114 29.1034C30.9118 28.5642 30.3445 28.4375 30.0243 28.4137C29.99 28.4093 29.9552 28.4062 29.9196 28.4062H25.8608C25.8254 28.4062 25.7908 28.4093 25.7565 28.4137C25.4364 28.4373 24.8688 28.564 24.269 29.1035C22.864 30.3666 22.1384 33.1083 22.1121 37.2522C22.11 37.588 22.3055 37.8781 22.5893 38.0146V38.6321H21.3198V46.1434H24.5239V38.6321H23.2546V38.0412C23.5674 37.9205 23.7907 37.6186 23.793 37.263C23.8168 33.492 24.4441 31.7093 24.9661 30.8779C24.9939 30.8336 25.0216 30.7922 25.049 30.7527V34.4135V36.4031V46.6983C25.049 47.4158 25.6307 47.9971 26.3478 47.9971C27.0651 47.9971 27.6467 47.4158 27.6467 46.6983V37.2151H28.1337V46.6983C28.1337 47.4158 28.7153 47.9971 29.4324 47.9971C30.1497 47.9971 30.7314 47.4158 30.7314 46.6983V36.4031V34.4135V30.7505C31.2936 31.5519 31.9624 33.3305 31.9873 37.263C31.9896 37.6187 32.2128 37.9206 32.5257 38.0413V38.6321H31.2564V46.1434H34.4605V38.6319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8901 27.8133C29.1955 27.8133 30.2538 26.7551 30.2538 25.4496C30.2538 24.1442 29.1955 23.0859 27.8901 23.0859C26.5846 23.0859 25.5264 24.1442 25.5264 25.4496C25.5264 26.7551 26.5846 27.8133 27.8901 27.8133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.501 24.3203L46.1988 27.9803L46.8965 24.3203C48.3275 24.0018 49.3975 22.7256 49.3975 21.1988C49.3975 19.4321 47.9654 18 46.1988 18C44.4321 18 43 19.4321 43 21.1988C43 22.7256 44.0702 24.0018 45.501 24.3203ZM46.1989 18.9448C47.4416 18.9448 48.4527 19.956 48.4527 21.1988C48.4527 22.4415 47.4416 23.4527 46.1989 23.4527C44.9561 23.4527 43.9448 22.4415 43.9448 21.1988C43.9448 19.956 44.9561 18.9448 46.1989 18.9448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1989 22.0327C46.661 22.0327 47.0356 21.6581 47.0356 21.196C47.0356 20.734 46.661 20.3594 46.1989 20.3594C45.7369 20.3594 45.3623 20.734 45.3623 21.196C45.3623 21.6581 45.7369 22.0327 46.1989 22.0327Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_315_1425",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.291667 0 0 0 0 0.291667 0 0 0 0 0.291667 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_315_1425"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_315_1425",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_315_1425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(20 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpressEntryIcon);
export default __webpack_public_path__ + "static/media/express-entry-icon.5aa4376261f37903c611e4439c7f1c87.svg";
export { ForwardRef as ReactComponent };